import { Download, Film, RefreshCw } from "lucide-react";
import { StatusPill } from "./shared";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function VideoPanel({ video, frameReady, onGenerate, model }) {
  if (!video) return null;
  const busy = video.status === "generating";
  const isErr = video.status?.startsWith("error");
  return (
    <div data-testid={`video-${video.id}`} style={{ marginTop: 18, borderTop: "1px solid var(--ink-06)", paddingTop: 18 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--ink-40)" }}>8s clip · {model}</span>
        <StatusPill status={video.status} />
      </div>
      {video.url && (
        <video data-testid={`video-player-${video.id}`} src={`${BACKEND_URL}${video.url}?t=${video.created_at}`} controls loop muted playsInline
          style={{ marginTop: 12, width: 200, aspectRatio: "9 / 16", borderRadius: 14, background: "#000", objectFit: "cover", opacity: busy ? .5 : 1 }} />
      )}
      {busy && <div className="serif pulse-dot" style={{ marginTop: 10, fontSize: 18, fontStyle: "italic", color: "var(--burgundy)" }}>Kling is rendering… typically 2–5 minutes</div>}
      {isErr && (
        <div data-testid={`video-error-${video.id}`} style={{ marginTop: 8, fontSize: 12, color: "var(--burgundy)", lineHeight: 1.5 }}>
          {video.status.replace(/^error:\s*/, "")}
          <button className="btn btn-ghost" data-testid={`retry-video-${video.id}`} disabled={!frameReady} onClick={() => onGenerate(video.id)} style={{ marginLeft: 10, padding: "4px 10px", fontSize: 11 }}>
            <RefreshCw size={11} />Retry
          </button>
        </div>
      )}
      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        <button className={`btn ${video.url ? "btn-ghost" : "btn-primary"}`} data-testid={`generate-video-${video.id}`} disabled={busy || !frameReady} title={!frameReady ? "Generate the key frame first" : undefined} onClick={() => onGenerate(video.id)}>
          {video.url ? <RefreshCw size={14} /> : <Film size={14} />}{video.url ? "Regenerate clip" : "Generate clip"}
        </button>
        {video.url && (
          <a className="btn btn-ghost" data-testid={`download-video-${video.id}`} href={`${BACKEND_URL}${video.url}`} download={`${video.id}.mp4`} target="_blank" rel="noreferrer"><Download size={14} />MP4</a>
        )}
      </div>
    </div>
  );
}
